import { render, staticRenderFns } from "./AlbumControls.vue?vue&type=template&id=83cc7064&"
import script from "./AlbumControls.vue?vue&type=script&lang=js&"
export * from "./AlbumControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports